import React from 'react';
// import i18n from "i18next";
import { Navbar, Container, NavDropdown } from 'react-bootstrap';
import { Nav } from 'react-bootstrap';
import logo from '../archivos/logos/4.png';
import './styles/Navbar.css';
import { withTranslation } from 'react-i18next';

class NavBar extends React.Component {
	constructor() {
		super();
		this.state = {
			info: [],
		};
	}

	render() {
		const { t, i18n } = this.props;
		const changeLanguage = (lng) => {
			i18n.changeLanguage(lng);
			localStorage.setItem('lang', lng);
		};

		return (
			<Container className='container'>
				<Navbar
					collapseOnSelect
					expand='lg'
					align='right'
					variant='dark'
					className='navbarr navbar-fixed-top'
				>
					<Navbar.Brand href='#Home'>
						<img src={logo} width='180' height='73' alt='Logo de Jedify' />
					</Navbar.Brand>
					<Navbar.Toggle aria-controls='responsive-navbar-nav' />
					<Navbar.Collapse className='navlinks' id='responsive-navbar-nav'>
						<Nav className='mr-auto'></Nav>
						<Nav.Link className='botonContactanos links' href='#Sumate' onClick={this.abrirModal}>
							{t('Footer.h5')}
						</Nav.Link>
						<Nav.Link className='links' href='#Conocenos'>
							{t('Navbar.link1')}
						</Nav.Link>

						<NavDropdown title={t('Navbar.link3.p1')} id="collasible-nav-dropdown" >
							{/* <NavDropdown.Item href="#Productos" className="item" >{t('Navbar.link2.p2')}</NavDropdown.Item> */}
							<NavDropdown.Item href="#Clientes" className="item" >{t('Navbar.link6.p2')}</NavDropdown.Item>
							<NavDropdown.Item href="#Servicios">{t('Navbar.link3.p2')}</NavDropdown.Item>
						</NavDropdown>
						{/* <Nav.Link className='links' href='#Capacidades'>
							{t('Navbar.link3.p2')}
						</Nav.Link>
						<Nav.Link className='links' href='#Clientes'>
							{t('Navbar.link6.p2')}
						</Nav.Link> */}

						{/* <Nav.Link className="links" href="#Sumate">{t('Navbar.link4')}</Nav.Link> */}

						<Nav.Link className='links' href='#Quienes'>
							{t('Navbar.link5.p1')}
						</Nav.Link>
						<Nav.Link className='links' href='#news'>
							{t('Navbar.link7.p1')}
						</Nav.Link>
						<Nav.Link className='links esR' href='#'>
							<span onClick={() => changeLanguage('es')}>ES</span> |{' '}
							<span onClick={() => changeLanguage('en')}>EN</span>
						</Nav.Link>
					</Navbar.Collapse>
				</Navbar>
			</Container>
		);
	}
}
export default withTranslation()(NavBar);
